var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Log } from '../../../../log';
import { AsciiText } from './AsciiText';
import { addReceiveListener, bind, close, create, getInfo, joinGroup, leaveGroup, removeReceiveListener, send, setBroadcast, setPaused, } from './ChromeAppsSocketsUdp';
const debug = false;
export function createUdpSocket() {
    return new UdpSocket();
}
export class UdpSocket {
    constructor() {
        this.log = Log.channel('UdpSocket');
    }
    addMembership(multicastAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.socketId === undefined)
                throw new Error(`addMembership: socket not initialized`);
            yield joinGroup(this.socketId, multicastAddress);
        });
    }
    bind(port) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.socketId === undefined)
                this.socketId = yield this.initialize();
            if (debug)
                this.log.debug(`bind: ${this.socketId}: binding`);
            const result = yield bind(this.socketId, '0.0.0.0', port);
            if (debug)
                this.log.debug(`bind: ${this.socketId}: result = ${JSON.stringify(result)}`);
        });
    }
    close() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (debug)
                this.log.debug(`close: ${this.socketId}: closing`);
            if (this.receiveListenerId !== undefined) {
                removeReceiveListener(this.receiveListenerId);
                this.receiveListenerId = undefined;
            }
            if (this.socketId !== undefined) {
                // need to pause before closing, otherwise will get an ioexception receive error
                const pauseResult = yield setPaused(this.socketId, true);
                if (debug) {
                    this.log.debug(`close: ${this.socketId}: pauseResult = ${JSON.stringify(pauseResult)}`);
                }
                const closeResult = yield close(this.socketId);
                if (debug) {
                    this.log.debug(`close: ${this.socketId}: closeResult = ${JSON.stringify(closeResult)}`);
                }
            }
            (_a = this.closeCallback) === null || _a === void 0 ? void 0 : _a.call(this);
        });
    }
    dropMembership(multicastAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.socketId === undefined)
                throw new Error(`dtopMembership: socket not initialized`);
            yield leaveGroup(this.socketId, multicastAddress);
        });
    }
    getAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.socketId === undefined) {
                throw new Error(`getAddress: socket not initialized`);
            }
            const info = yield getInfo(this.socketId);
            if (info.localAddress === undefined || info.localPort === undefined) {
                throw new Error(`getAddress: no address or port; socket may not be bound`);
            }
            return { address: info.localAddress, port: info.localPort };
        });
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            if (debug)
                this.log.debug(`initialize: initializing`);
            const socketId = yield create({ name: 'UdpSocket' });
            if (debug)
                this.log.debug(`initialize: ${socketId}`);
            if (this.receiveListenerId !== undefined) {
                this.log.error(`receiveListenerId not undefined`);
            }
            this.receiveListenerId = addReceiveListener(socketId, info => {
                if (this.messageCallback) {
                    this.messageCallback({
                        address: info.remoteAddress,
                        message: AsciiText.decode(new Uint8Array(info.data)),
                        port: info.remotePort,
                    });
                }
            }, errorInfo => {
                var _a, _b, _c;
                if (errorInfo instanceof Error) {
                    (_a = this.errorCallback) === null || _a === void 0 ? void 0 : _a.call(this, errorInfo);
                }
                else if (typeof errorInfo === 'string') {
                    (_b = this.errorCallback) === null || _b === void 0 ? void 0 : _b.call(this, new Error(errorInfo));
                }
                else {
                    (_c = this.errorCallback) === null || _c === void 0 ? void 0 : _c.call(this, new Error(JSON.stringify(errorInfo)));
                }
            });
            return socketId;
        });
    }
    onClose(closeCallback) {
        this.closeCallback = closeCallback;
    }
    onError(errorCallback) {
        this.errorCallback = errorCallback;
    }
    onMessage(messageCallback) {
        this.messageCallback = messageCallback;
    }
    send(address, port, message) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.socketId === undefined)
                this.socketId = yield this.initialize();
            if (debug)
                this.log.debug(`send: ${this.socketId}: sending to ${address}:${port}`);
            const result = yield send(this.socketId, AsciiText.encode(message).buffer, address, port);
            if (debug)
                this.log.debug(`send: ${this.socketId}: result = ${JSON.stringify(result)}`);
        });
    }
    setBroadcast(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.socketId === undefined)
                throw new Error(`setBroadcast: socket not initialized`);
            return setBroadcast(this.socketId, enabled);
        });
    }
}
